import { apiService } from "../../app.service";

export const accountsApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchUsers: builder.query({
      query: () => ({
        url: "/user",
      }),
    }),
  }),
});

export const { useFetchUsersQuery } = accountsApi;
